(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/use-jackpot/assets/javascripts/use-jackpot.js') >= 0) return;  svs.modules.push('/components/lb-utils/use-jackpot/assets/javascripts/use-jackpot.js');

'use strict';

const {
  log
} = svs.core;
const {
  productIds
} = svs.utils.products;
const {
  filterByProducts
} = svs.content.shared.jackpotHelpers;
const logger = log.getLogger('lb-utils:jackpots');
const JackpotError = Object.freeze({
  INVALID_DRAW_NUMBER: 'drawNumber has to be an integer',
  INVALID_DRAW_NUMBERS: 'drawNumbers has to be an array of integers',
  INVALID_PRODUCT_ID: 'product has to be a valid productId as string or an integer',
  INVALID_PRODUCT_IDS: 'products has to be an array of valid productId as string or an integer'
});





const filterByDrawNumber = (drawNumbers, jackpots) => {
  if (drawNumbers.length) {
    return jackpots.filter(j => drawNumbers.includes(j.drawNumber));
  }
  return jackpots;
};

const fetchJackpotResults = function () {
  let products = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let drawNumbers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const {
    error,
    jackpots
  } = svs.lbUtils.jackpots.data;
  let filteredJackpots = filterByProducts(Array.isArray(products) ? products : [products], jackpots);
  filteredJackpots = filterByDrawNumber(Array.isArray(drawNumbers) ? drawNumbers : [drawNumbers], filteredJackpots);
  logger.info("Fetching jackpots... Returning ".concat(filteredJackpots.length, "/(").concat(jackpots.length, ")."));
  return {
    error,
    jackpots: filteredJackpots.sort((a, b) => a.productId - b.productId)
  };
};

const useJackpots = function () {
  let products = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let drawNumbers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const validProductIds = Object.values(productIds);
  const productIdsAreValid = !products.find(product => !validProductIds.includes(Number(product)));
  if (!productIdsAreValid) {
    logger.info("useJackpot: ".concat(JackpotError.INVALID_PRODUCT_IDS));
    throw new Error(JackpotError.INVALID_PRODUCT_IDS);
  }
  const drawNumbersAreValid = !drawNumbers.find(drawNumber => !Number.isInteger(drawNumber));
  if (drawNumbers.length && !drawNumbersAreValid) {
    logger.info("useJackpot: ".concat(JackpotError.INVALID_DRAW_NUMBERS));
    throw new Error(JackpotError.INVALID_DRAW_NUMBERS);
  }
  return fetchJackpotResults(products, drawNumbers);
};

const useJackpot = (product, drawNumber) => {
  if (!Object.values(productIds).includes(Number(product))) {
    logger.info("useJackpot: ".concat(JackpotError.INVALID_PRODUCT_ID));
    throw new Error(JackpotError.INVALID_PRODUCT_ID);
  }
  if (drawNumber && !Number.isInteger(drawNumber)) {
    logger.info("useJackpot: ".concat(JackpotError.INVALID_DRAW_NUMBER));
    throw new Error(JackpotError.INVALID_DRAW_NUMBER);
  }
  const {
    error,
    jackpots
  } = fetchJackpotResults([product], drawNumber ? [drawNumber] : undefined);
  return {
    error,
    jackpot: jackpots === null || jackpots === void 0 ? void 0 : jackpots[0]
  };
};
setGlobal('svs.components.lbUtils.useJackpot', useJackpot);
setGlobal('svs.components.lbUtils.useJackpots', useJackpots);

 })(window);